import ApiService from '@/services/ApiService';

export default class ChildWeightRecordsApiService extends ApiService {
    constructor() {
        super('child_weight_records');
    }
}
